var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`formGroup ${
    _vm.$vuetify.breakpoint.xsOnly ? '' : 'd-flex align-center flex-wrap'
  }`},[(_vm.header)?_c('legend',{class:`text-body-2 text-uppercase ${
      _vm.dense ? '' : 'pr-2 '
    }v-subheader secondary--text`},[_vm._v(" "+_vm._s(_vm.header)+": ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }